import { FormControl, MenuItem } from '@mui/material';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { getNeighborhoods } from '../../fetch';
import { getCommonNeighborhoods } from '../../fetch/lookups';
import { alphaSort } from '../../helpers';
import { INeighborhoodRes, INeighborhood } from '../../models';
import { SMBSelect } from '../input';

interface INeighborhoodDropdownProps {
  value: string | number;
  handleChange: (val: string | number) => void;
  isDisabled?: boolean;
  setOptions?: (val: INeighborhood[]) => void;
  apiParams?: any;
  isRequired?: boolean;
  inputLabel?: string;
  returnNeighborhoodName?: boolean;
  name?: string;
  handleClear?: () => void;
  isAdminPortal?: boolean;
}

export const NeighborhoodDropdown: FC<INeighborhoodDropdownProps> = ({
  inputLabel,
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  apiParams,
  returnNeighborhoodName,
  name,
  handleClear,
  isAdminPortal = false
}) => {
  const fetchNeighborhoods = () =>
    isAdminPortal ? getNeighborhoods(apiParams) : getCommonNeighborhoods(apiParams);

  const { isLoading: isLoadingNeighborhoods, data: neighborhoodsData } = useQuery<
    INeighborhoodRes,
    Error
  >(['neighborhoods-filters', apiParams, isAdminPortal], fetchNeighborhoods, {
    notifyOnChangeProps: 'tracked',
    onSuccess: d => setOptions?.(d.records)
  });

  const neighborhoods = useMemo(
    () =>
      neighborhoodsData?.records?.map(r => ({
        ...r,
        fullName: `${r.name} Phase ${r.phase}`
      })) ?? [],
    [neighborhoodsData]
  );
  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired}>
      <SMBSelect
        name={name || null}
        disabled={isDisabled || isLoadingNeighborhoods}
        label={isLoadingNeighborhoods ? 'Loading...' : inputLabel ?? 'Neighborhood'}
        value={value}
        required={isRequired}
        onChange={({ target: { value } }) => {
          handleChange(returnNeighborhoodName ? value : Number(value));
        }}
        handleClear={() => {
          handleChange('');
          handleClear && handleClear();
        }}
        SelectProps={{
          MenuProps: {
            sx: {
              maxHeight: '30rem'
            }
          }
        }}
      >
        {!isLoadingNeighborhoods && neighborhoods && neighborhoods.length === 0 && (
          <MenuItem disabled>No Neighborhoods available</MenuItem>
        )}
        {!isLoadingNeighborhoods &&
          neighborhoods &&
          alphaSort(neighborhoods, 'fullName').map((neighborhood, index) => {
            return (
              <MenuItem
                key={`neighborhood-${neighborhood.neighborhoodId}`}
                value={returnNeighborhoodName ? neighborhood.name : neighborhood.neighborhoodId}
              >
                {returnNeighborhoodName ? neighborhood.name : neighborhood.fullName}
              </MenuItem>
            );
          })}
      </SMBSelect>
    </FormControl>
  );
};
